// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom transition classes for react-transition-group */
.fade-enter {
    opacity: 0;
  }
  .fade-enter-active {
    opacity: 1;
    transition: opacity 500ms;
  }
  .fade-exit {
    opacity: 1;
  }
  .fade-exit-active {
    opacity: 0;
    transition: opacity 500ms;
  }
  
  .badge {
    border-radius: 0.25rem;
    --tw-bg-opacity: 1;
    background-color: rgb(220 38 38 / var(--tw-bg-opacity));
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 700;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity));
    top: 0.5rem;
    right: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/Admin/pages/notification.css"],"names":[],"mappings":"AAAA,yDAAyD;AACzD;IACI,UAAU;EACZ;EACA;IACE,UAAU;IACV,yBAAyB;EAC3B;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,yBAAyB;EAC3B;;EAGE;IAAA,sBAAgE;IAAhE,kBAAgE;IAAhE,uDAAgE;IAAhE,oBAAgE;IAAhE,qBAAgE;IAAhE,oBAAgE;IAAhE,uBAAgE;IAAhE,kBAAgE;IAAhE,iBAAgE;IAAhE,gBAAgE;IAAhE,oBAAgE;IAAhE,gDAAgE;IAChE,WAAW;IACX;AAFgE","sourcesContent":["/* Custom transition classes for react-transition-group */\n.fade-enter {\n    opacity: 0;\n  }\n  .fade-enter-active {\n    opacity: 1;\n    transition: opacity 500ms;\n  }\n  .fade-exit {\n    opacity: 1;\n  }\n  .fade-exit-active {\n    opacity: 0;\n    transition: opacity 500ms;\n  }\n  \n  .badge {\n    @apply bg-red-600 text-white text-xs font-bold px-2 py-1 rounded;\n    top: 0.5rem;\n    right: 0.5rem;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
